const {databaseServer} = require("../config/network");

const login = async (username, password) => {
    try {
        return fetch(`${databaseServer}/login`, {
            method: 'POST',
            mode: 'cors',
            body: JSON.stringify({username, password}),
            headers: {'Content-Type': 'application/json'}
        })
            .then(response => response.json())
            .catch(error => console.log(error));
    } catch (error) {
        return { error }
    }
}

const updatePassword = async (token, password) => {
    return fetch(`${databaseServer}/update-password`, {
        method: 'POST',
        mode: 'cors',
        body: JSON.stringify({password}),
        headers: {
            'Content-Type': 'application/json',
            'Authorization': token
        }
    })
        .then(response => response.json() )
        .catch(error => console.log(error));
}

module.exports = {
    login,
    updatePassword
}